import { differenceInCalendarDays } from 'date-fns';
import { dissoc, isEmpty } from 'ramda';
import { createAction } from 'redux-actions';

import { USER_ROLES } from 'constants/general';
import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import { saveFile } from 'features/common/fileSave/actions';
import dashboardStructure from 'features/views/campaignDashboards/structure';
import user from 'features/views/user';

import * as types from './actionTypes';
import { REPORT_NOT_FOUND_DIALOG } from './constants';
import { getLastSummaryRequest } from './selectors';

const saveLastSummaryRequest = createAction(types.SAVE_LAST_SUMMARY_REQUEST, (request) => ({ request }));
const setSummary = createAction(types.SET_SUMMARY, (summary) => ({ summary }));
export const removeSummary = createAction(types.REMOVE_SUMMARY, (summary) => ({ summary }));

export const fetchSummary = (campaign, url, organizationStructure) => (dispatch, getState) => {
	if (isEmpty(campaign)) return false;
	const { id, endDate, startDate } = campaign;
	const userRole = user.selectors.getCurrentRole(getState());
	dispatch(saveLastSummaryRequest({ campaign, url, organizationStructure }));
	dispatch(
		fetch.actions.post(url, {
			body: {
				userRole,
				campaignId: id,
				dashboardOrganisationStructureFilters: organizationStructure,
			},
			onSuccess: [
				(response) => () => {
					const campaignDuration = differenceInCalendarDays(new Date(endDate), new Date(startDate));
					const campaignDaysFromStart = differenceInCalendarDays(new Date(), new Date(startDate));
					const campaignDaysTillEnd = differenceInCalendarDays(new Date(endDate), new Date());

					const campaignProgress =
						campaignDaysFromStart < 0
							? 0
							: campaignDaysFromStart > campaignDuration
							  ? 100
							  : (campaignDaysFromStart / campaignDuration) * 100;

					dispatch(
						setSummary({
							...response.body,
							campaignProgress,
							campaignType: campaign.type,
							endDate,
							startDate,
							timeTillEndOfCampaign: campaignDaysTillEnd < 0 ? 0 : campaignDaysTillEnd,
						}),
					);
				},
			],
		}),
	);
};

export const reloadSummary = () => (dispatch, getState) => {
	const lastRequest = getLastSummaryRequest(getState());
	if (!lastRequest) return;
	const { campaign, url, organizationStructure } = lastRequest;
	dispatch(fetchSummary(campaign, url, organizationStructure));
};

export const reportCampaign = (campaignId) => async (dispatch, getState) => {
	dispatch(dialog.actions.close(REPORT_NOT_FOUND_DIALOG));
	const state = getState();
	const currentView = dashboardStructure.selectors.getView(state);
	const organizationStructures = dashboardStructure.selectors.getStructure(state);
	const userRole = user.selectors.getCurrentRole(state);
	let finalOrganizationStructures = organizationStructures;

	if (currentView === dashboardStructure.constants.views.REGION) {
		const regionOrgStructure = organizationStructures.map(dissoc('manager'));
		finalOrganizationStructures = regionOrgStructure;

		if (userRole === USER_ROLES.GUARANTOR) {
			const regionGuarantorOrgStructure = regionOrgStructure.map(dissoc('channelId'));
			finalOrganizationStructures = regionGuarantorOrgStructure;
		}
	}

	const response = await dispatch(
		fetch.actions.postBinary(fetch.constants.urls.dashboardReport, {
			body: {
				campaignId,
				userRole,
				dashboardOrganisationStructureFilters: finalOrganizationStructures,
			},
		}),
	);

	if (!response.body) {
		return dispatch(dialog.actions.open(REPORT_NOT_FOUND_DIALOG));
	}

	saveFile({ response });
};
